import { useState } from 'react';
import {
  createUserWithEmailAndPassword,
  updateProfile,
  sendEmailVerification,
} from 'firebase/auth';
import { ref, set } from 'firebase/database';
import { auth, rtdb } from '../firebase.config';

const useSignup = () => {
  const [loading, setLoading] = useState(false);

  const signup = async (values, onSuccess, onError) => {
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );

      const user = userCredential.user;

      await updateProfile(user, {
        displayName: values.username,
      });

      await set(ref(rtdb, 'landlords/' + user.uid), {
        uid: user.uid,
        username: values.username,
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        phone: values.phone,
        createdAt: new Date().toISOString(),
      });

      await sendEmailVerification(user, {
        //url: 'http://localhost:3000/signin',
        url: 'https://mogul-cloud-dev.pages.dev/signin',
        handleCodeInApp: true,
      });

      if (onSuccess) onSuccess(user);
    } catch (err) {
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  return { signup, loading };
};

export default useSignup;
